import { PageHeader } from '@repo/ui/components/page-header'
import { formatLocaleDate } from '@repo/ui/dates'
import { Skeleton } from '@repo/ui/skeleton'
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow
} from '@repo/ui/table'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import { useTranslation } from '@/lib/i18n'
import { LegalTextsNote } from './-components/legal-texts-note'
import { emailTextsQueryOptions } from './-query/query-options'

export const Route = createFileRoute('/(private)/email-texts/')({
	component: EmailTextsPage
})

/** "Testi delle email" (FFD 3.8): the emails without legal value. */
function EmailTextsPage() {
	const { t } = useTranslation()
	const query = useQuery(emailTextsQueryOptions())

	return (
		<main className='flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto p-4 md:p-6'>
			<PageHeader title={t('admin-email-texts:page_title')} />
			{query.isLoading && <Skeleton className='h-40 w-full' />}
			{query.isError && (
				<p className='text-muted-foreground text-sm'>
					{t('admin-email-texts:error')}
				</p>
			)}
			{query.data && (
				<Table>
					<TableHeader>
						<TableRow>
							<TableHead>
								{t('admin-email-texts:columns.email')}
							</TableHead>
							<TableHead>
								{t('admin-email-texts:columns.it')}
							</TableHead>
							<TableHead>
								{t('admin-email-texts:columns.en')}
							</TableHead>
						</TableRow>
					</TableHeader>
					<TableBody>
						{query.data.map((text) => (
							<TableRow key={text.code}>
								<TableCell>
									<Link
										className='font-medium hover:underline'
										params={{ code: text.code }}
										to='/email-texts/$code'
									>
										{text.code} ·{' '}
										{t(
											`admin-email-texts:emails.${text.code as 'E1' | 'G1' | 'G10'}`
										)}
									</Link>
								</TableCell>
								{text.locales.map((locale) => (
									<TableCell
										className='tabular-nums'
										key={locale.locale}
									>
										{locale.current.createdAt
											? t(
													'admin-email-texts:version_on',
													{
														version:
															locale.current
																.version,
														date: formatLocaleDate(
															locale.current
																.createdAt,
															'P'
														)
													}
												)
											: t(
													'admin-email-texts:default_text'
												)}
									</TableCell>
								))}
							</TableRow>
						))}
					</TableBody>
				</Table>
			)}
			<LegalTextsNote />
		</main>
	)
}
